import React from 'react';
import SnakeGame from './SnakeGame';

function App() {
    return (
        <div className="App">

            <SnakeGame />
        </div>
    );
}

export default App;
